require('../../modules/es6.string.repeat');
module.exports = require('../../modules/_core').String.repeat;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/fn/string/repeat.js
// module id = 278
// module chunks = 0